import { keyframes } from '@emotion/react'
import styled from '@emotion/styled'

import { COLORS } from '@/styles/colors'

/** 아래에서 위로 떠오르는 진입 인터랙션 — transform/opacity 만 사용(컴포지트) */
const slideUp = keyframes`
  from {
    transform: translateY(12px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
`

/** 아래로 스르륵 사라지는 퇴장 인터랙션 */
const slideDown = keyframes`
  from {
    transform: translateY(0);
    opacity: 1;
  }
  to {
    transform: translateY(12px);
    opacity: 0;
  }
`

export const ToastViewportContainer = styled.div`
  position: fixed;
  left: 16px;
  right: 16px;
  /* CTA 버튼(FloatingCtaBar) 상단에서 24px 위 — 버튼 상단 86px(버튼 66 + 패딩 20) + 간격 24px */
  bottom: calc(110px + var(--safe-bottom, 0px));
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  z-index: 9999;
  pointer-events: none;
`

export const ToastItemElement = styled('div', {
  shouldForwardProp: (prop) => prop !== 'exiting',
})<{ exiting: boolean }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  max-width: 100%;
  padding: 12px 24px;
  border-radius: 9999px;
  background-color: ${COLORS.bgElevated};
  color: ${COLORS.textInverse};
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  letter-spacing: -0.5px;
  /* pre-line — 메시지의 \n 을 줄바꿈으로 렌더(결제 거절 message+description 등).
     긴 줄은 컨테이너 폭(viewport-32) 안에서 wrap. 한 줄 토스트는 그대로 단일 행 유지. */
  white-space: pre-line;
  word-break: keep-all;
  text-align: center;
  pointer-events: auto;
  box-shadow:
    0 6px 4px rgba(0, 0, 0, 0.12),
    0 0 1px rgba(0, 0, 0, 0.08);
  /* forwards — 애니메이션 종료 후 마지막 프레임(exit 시 opacity:0) 유지. removeTimer 와의 타이밍 경합 시 깜빡임 방지 */
  animation: ${({ exiting }) => (exiting ? slideDown : slideUp)} 700ms cubic-bezier(0.16, 1, 0.3, 1) forwards;
  will-change: transform, opacity;
`
